"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSportTypeBySport = void 0;
var immutable_1 = require("immutable");
var constants_1 = require("../constants");
var types_1 = require("../types");
function getSportTypeBySportTags(sports, selectedSportIds) {
    var selectedSportsSet = new Set(selectedSportIds);
    var selectedSports = sports.filter(function (sport) {
        return selectedSportsSet.has(sport.id);
    });
    if (selectedSports.every(function (sport) {
        return sport.tags.includes(types_1.GQL.SportTag.ESPORT);
    })) {
        return constants_1.SportType.Esport;
    }
    if (selectedSports.every(function (sport) {
        return sport.tags.includes(types_1.GQL.SportTag.CLASSIC);
    })) {
        return constants_1.SportType.Classic;
    }
    return constants_1.SportType.Mix;
}
function getSportTypeBySport(sport) {
    var _a;
    if (!sport)
        return undefined;
    return getSportTypeBySportTags(immutable_1.Map((_a = {}, _a[sport.id] = sport, _a)), [sport.id]);
}
exports.getSportTypeBySport = getSportTypeBySport;
exports.default = getSportTypeBySportTags;
//# sourceMappingURL=getSportTypeBySportTags.js.map